// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1FtqS","title":"Images45_title__1wcBS","images":"Images45_images__3eprJ"};